import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const LoadingShimmer = ({styles = {}}) => {
  return <span className="ndx-LoadingShimmer" aria-busy style={styles} />;
};
const propTypes = {
  styles: PropTypes.object
};

LoadingShimmer.propTypes = propTypes;

export default LoadingShimmer;
